const SelectCustomStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '8px',
    borderColor: '#dee2e6',
    fontSize: '0.875rem'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#f0f0f0' : '#fff',
    color: '#333',
    '&:hover': {
      backgroundColor: '#eee',
    },
  }),
};

export default SelectCustomStyles;